import styles from "./sportCardsService.module.scss";
import { defoltData, stepsDefaultData } from "./constatns";
import { useState } from "react";
import Steps from "./steps/steps";
import SportCardsGeneratorServiceResult from "./result/result";
import Editor from "./editor/ediror";


const SportCardsService = () => {
  const [sportCardsState, setSportCardsState] = useState({ ...defoltData });
  const [steps, setSteps] = useState(stepsDefaultData);

  return (
    <div className={`${styles.sportCardsService} ${steps.find((step) => step.active)?.name === "Download" ? styles.final : ""}`}>
      <Steps steps={steps} setSteps={setSteps} sportCardsState={sportCardsState} />
      <Editor activeStep={steps.find((step) => step.active)} setSteps={setSteps} sportCardsState={sportCardsState} setSportCardsState={setSportCardsState} />
      {steps.find((step) => step.active)?.name !== "Download" && <SportCardsGeneratorServiceResult sportCardsState={sportCardsState} />}
    </div>
  )
}

export default SportCardsService